import styled from 'styled-components';

import { GridItem } from '@xing-com/grid';
import { mediaConfined } from '@xing-com/layout-tokens';
import { spaceXL, space3XL, space4XL, space5XL } from '@xing-com/tokens';

export const StyledSection = styled(GridItem)<{ $hero?: boolean }>`
  padding: ${({ $hero }) =>
    $hero ? `${spaceXL} 0 ${space3XL}` : `0 0 ${space3XL}`};

  @media ${mediaConfined} {
    padding: ${({ $hero }) =>
      $hero ? ` ${space4XL} 0 ${space5XL}` : `0 0 ${space5XL}`};
  }
`;
